<script setup lang="ts" name="SailingScheduleTradeLaneVoyagesLayout">
import SailingScheduleTradeLaneHeading from '~/components/SailingScheduleTradeLaneHeading.vue';
</script>

<template>
  <div class="grid w-full grid-cols-[14rem_minmax(0px,_1fr)]">
    <div class="rounded-b bg-white">
      <div class="right-shadow border-y border-r border-charcoal-2">
        <SailingScheduleTradeLaneHeading class="flex items-center">
          Ports / Vessel Voyage
        </SailingScheduleTradeLaneHeading>
      </div>

      <slot />
    </div>

    <slot name="vessels" />
  </div>
</template>
